module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.agenda.UnidadeLuandre !== undefined) ? _c('div', {
    staticClass: "container",
    attrs: {
      "id": "boxAgenda"
    }
  }, [_c('h3', [_vm._v(" Agenda de Atendimento "), _c('span', {
    staticClass: "label label-warning"
  }, [_vm._v(_vm._s(this.unidadeNome(_vm.filial)))])]), _vm._v(" "), _c('div', {
    staticClass: "text-left"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group  col-lg-6"
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isHabilitado),
      expression: "isHabilitado"
    }],
    staticClass: "col-lg-6",
    staticStyle: {
      "margin-top": "7px"
    },
    attrs: {
      "for": "DataAgenda"
    }
  }, [_vm._v("Agenda do Dia: ")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isHabilitado),
      expression: "!isHabilitado"
    }],
    staticClass: "col-lg-6",
    staticStyle: {
      "margin-top": "7px"
    },
    attrs: {
      "for": "DataAgenda"
    }
  }, [_vm._v("Atualizando... ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isHabilitado),
      expression: "isHabilitado"
    }],
    staticClass: "fa fa-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isHabilitado),
      expression: "!isHabilitado"
    }],
    staticClass: "fa fa-circle-o-notch fa-spin"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.diaAtual),
      expression: "diaAtual"
    }],
    staticClass: "form-control ",
    staticStyle: {
      "font-size": "19px"
    },
    attrs: {
      "type": "date",
      "id": "DataAgenda"
    },
    domProps: {
      "value": (_vm.diaAtual)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.carregarAgenda($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.diaAtual = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-lg-6"
  }, [_c('label', {
    staticClass: "col-lg-6"
  }, [_vm._v("Histórico de agendamento do candidato: ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('###.###.###-##'),
      expression: "'###.###.###-##'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.cpfHistorico),
      expression: "cpfHistorico"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Digite o CPF"
    },
    domProps: {
      "value": (_vm.cpfHistorico)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.abreModalHistoricoCandidato($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cpfHistorico = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.abreModalHistoricoCandidato
    }
  }, [_c('span', [_vm._v("Pesquisar")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [(_vm.agenda.QuantidadeAssessores == 0) ? _c('div', [_vm._m(0)]) : _c('div', [_c('table', {
    staticClass: "table table-responsive table-stripped  table-bordered",
    staticStyle: {
      "background": "#fcfcfc"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "max-width": "100px !important",
      "width": "100px"
    }
  }, [_vm._v("Horário")]), _vm._v(" "), _vm._l((_vm.agenda.QuantidadeAssessores), function(indice) {
    return _c('th', {
      key: indice
    }, [_vm._v("\n                            Assessor " + _vm._s(indice) + "\n                          ")])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.agenda.Horarios), function(hora) {
    return _c('tr', {
      key: hora
    }, [(!(((_vm.agenda.BloqueioAgendaInicio !== '00:00:00') && (_vm.agenda.BloqueioAgendaFim !== '00:00:00')) && (hora >= _vm.agenda.BloqueioAgendaInicio && hora < _vm.agenda.BloqueioAgendaFim))) ? _c('td', {
      staticClass: "td-horarios"
    }, [_c('a', {
      attrs: {
        "href": "#",
        "data-toggle": "modal"
      },
      on: {
        "click": function($event) {
          _vm.horarioSelecionado = hora;
          _vm.validaQtdeAssessor($event)
        }
      }
    }, [_vm._v(" " + _vm._s(hora.substr(0, 5)) + " ")]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), (_vm.podeBloquear) ? _c('a', {
      staticClass: "btn btn-primary",
      staticStyle: {
        "font-size": "13px"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.bloquearHorario(hora.substr(0, 5))
        }
      }
    }, [_vm._v(" Bloquear Horario ")]) : _vm._e()]) : _c('td', {
      staticClass: "td-horarios"
    }, [_vm._v("   " + _vm._s(hora.substr(0, 5)) + " "), _c('br'), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('br')]), _vm._v(" "), _vm._l((_vm.agenda.Agendamento), function(agendado) {
      return (agendado.DataHorario.substr(11) == hora) ? _c('td', {
        key: agendado,
        staticClass: "td-marcados",
        attrs: {
          "rowspan": agendado.QtdeColetivo == null || agendado.QtdeColetivo < 5 ? (30 / _vm.agenda.IntervaloAtendimento) * 1 : agendado.QtdeColetivo >= 5 && agendado.QtdeColetivo < 10 ? (30 / _vm.agenda.IntervaloAtendimento) * 2 : agendado.QtdeColetivo >= 10 && agendado.QtdeColetivo < 15 ? (30 / _vm.agenda.IntervaloAtendimento) * 3 : agendado.QtdeColetivo >= 15 && agendado.QtdeColetivo < 20 ? (30 / _vm.agenda.IntervaloAtendimento) * 4 : (30 / _vm.agenda.IntervaloAtendimento) * 5
        }
      }, [(agendado.Tipo == 3) ? _c('div', [(_vm.idUsuario == agendado.Usuario.Id) ? _c('span', [_c('a', {
        staticStyle: {
          "float": "right",
          "color": "#d9534f"
        },
        attrs: {
          "href": "#",
          "title": "Excluir"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.excluirAgendamento(agendado.Id)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-window-close",
        attrs: {
          "aria-hidden": "true"
        }
      })])]) : _vm._e(), _vm._v(" "), _c('p', {
        staticClass: "text-left"
      }, [_c('strong', [_vm._v("Bloqueado Por: ")]), _c('small', [_vm._v(" " + _vm._s(agendado.Usuario.Nome))])]), _vm._v(" "), _c('strong', {
        staticClass: "strongBloqueado"
      }, [_vm._v("BLOQUEADO")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
        staticClass: "text-left"
      }, [_c('strong', [_vm._v("Motivo: ")]), _vm._v(" "), _c('br'), _vm._v(_vm._s(agendado.Observacoes))])]) : _c('div', [_c('ul', {
        staticClass: "list-group"
      }, [_c('li', {
        staticClass: "list-group-item text-left"
      }, [(_vm.idUsuario == agendado.Usuario.Id) ? _c('span', [(agendado.Coletivo === true) ? _c('span', [_c('a', {
        staticClass: "btn-exclusao",
        attrs: {
          "href": "#",
          "title": "Excluir"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.excluirAgendamentoColetivo(agendado)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-window-close",
        attrs: {
          "aria-hidden": "true"
        }
      })])]) : _c('span', [_c('a', {
        staticClass: "btn-exclusao",
        attrs: {
          "href": "#",
          "title": "Excluir"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.excluirAgendamento(agendado.Id)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-window-close",
        attrs: {
          "aria-hidden": "true"
        }
      })])])]) : _vm._e(), _vm._v(" "), _c('strong', [_vm._v("Objetivo: ")]), _vm._v(" "), (agendado.Tipo == 0) ? _c('small', {
        staticClass: "label label-info",
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "title": agendado.Observacoes == null || agendado.Observacoes == '' ? 'Nenhuma observação' : agendado.Observacoes
        }
      }, [_vm._v(" Admissão ")]) : _vm._e(), _vm._v(" "), (agendado.Tipo == 1) ? _c('small', {
        staticClass: "label label-danger",
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "title": agendado.Observacoes == null || agendado.Observacoes == '' ? 'Nenhuma observação' : agendado.Observacoes
        }
      }, [_vm._v(" Rescisão ")]) : _vm._e(), _vm._v(" "), (agendado.Tipo == 2) ? _c('small', {
        staticClass: "label label-default",
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "title": agendado.Observacoes == null || agendado.Observacoes == '' ? 'Nenhuma observação' : agendado.Observacoes
        }
      }, [_vm._v(" Outros ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Agendado Por: ")]), _vm._v(" "), _c('small', [_vm._v(" " + _vm._s(agendado.Usuario.Nome))])]), _vm._v(" "), _c('li', {
        staticClass: "list-group-item text-left"
      }, [(agendado.Coletivo === true) ? _c('strong', [_vm._v("\n                                    Coletivo:\n                                  ")]) : _c('strong', [_vm._v("\n                                    Candidato:\n                                  ")]), _vm._v(" "), (agendado.Coletivo === true) ? _c('small', [_vm._v("\n                                    " + _vm._s(agendado.TextoColetivo) + "\n\n                                    "), (agendado.CandidatosColetivo && agendado.CandidatosColetivo.length > 0) ? _c('div', {
        attrs: {
          "title": agendado.CandidatosColetivo.join(', ').replace(/,(?!.*,)/gmi, ' e ')
        }
      }, [_c('strong', [_vm._v("Candidatos:")]), _vm._v(" " + _vm._s(agendado.CandidatosColetivo.join(', ').replace(/,(?!.*,)/gmi, ' e ').substr(0, 120)) + "\n                                    ")]) : _vm._e()]) : _c('span', [_c('small', {
        attrs: {
          "title": agendado.Candidato.Nome
        }
      }, [_vm._v(_vm._s(agendado.Candidato.Nome.substr(0, 30)) + " "), (agendado.Candidato.CPF != null) ? _c('span', [_c('br'), _c('strong', [_vm._v("CPF: ")]), _vm._v(" " + _vm._s(agendado.Candidato.CPF) + " ")]) : _vm._e(), _vm._v(" "), (agendado.FichaAprovacao != null) ? _c('span', [_c('br'), _c('strong', [_vm._v("Ficha de Aprovacao: ")]), _vm._v(" " + _vm._s(agendado.FichaAprovacao.Id) + " ")]) : _vm._e()])])]), _vm._v(" "), (agendado.Empresa.RazaoSocial != undefined) ? _c('li', {
        staticClass: "list-group-item text-left"
      }, [_c('strong', [_vm._v("Empresa: ")]), _vm._v(" "), _c('small', {
        attrs: {
          "title": agendado.Empresa.RazaoSocial
        }
      }, [_vm._v("\n                                    " + _vm._s(agendado.Empresa.RazaoSocial == undefined ? '' : agendado.Empresa.RazaoSocial.substr(0, 40)) + "\n                                  ")])]) : _vm._e(), _vm._v(" "), (agendado.Observacoes != null && agendado.Observacoes != '') ? _c('li', {
        staticClass: "list-group-item text-left"
      }, [_c('strong', [_vm._v("Obs.: ")]), _vm._v(" "), _c('small', {
        attrs: {
          "title": agendado.Observacoes
        }
      }, [_vm._v("\n                                    " + _vm._s(agendado.Observacoes.substr(0, 114)) + "\n                                  ")])]) : _vm._e()])])]) : _vm._e()
    })], 2)
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
    staticStyle: {
      "background": "#2d618e",
      "min-height": "10px",
      "max-height": "10px",
      "font-size": "5px"
    },
    attrs: {
      "colspan": _vm.agenda.QuantidadeAssessores + 1
    }
  }, [_vm._v("   ")])])])])])])]), _vm._v(" "), _c('ModalAgendar', {
    attrs: {
      "dia": this.diaAtual,
      "hora": _vm.horarioSelecionado,
      "HoraAdmissao": _vm.agenda.FimAdmissao
    },
    on: {
      "atualizarAgenda": _vm.carregarAgenda
    }
  })], 1) : _c('div', {
    staticClass: "container"
  }, [_vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "label label-warning atualizacaoAutomatica"
  }, [_vm._v("\n    Próxima atualização automática: " + _vm._s(_vm.count) + "\n  ")]), _vm._v(" "), _c('ModalHistoricoCandidato', {
    ref: "modalHistorico"
  }), _vm._v(" "), _c('ModalBloquearHorario', {
    ref: "modalBloquear",
    attrs: {
      "QuantidadeAssessores": this.agenda.QuantidadeAssessores
    },
    on: {
      "atualizarAgenda": _vm.carregarAgenda
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("  :: Não existe uma agenda configurada para esta unidade "), _c('br'), _vm._v(" ou não há horários disponíveis para esse dia ::  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', {
    staticClass: "label label-danger"
  }, [_vm._v(" Horário "), _c('br'), _vm._v(" Reservado ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v(" :: Não foi possível conectar-se ao servidor :: "), _c('br'), _c('br'), _vm._v(" :: Contate a área de Projetos ::")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73de6fa1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Agenda.vue
// module id = 297
// module chunks = 1